import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

interface CloseButtonSignature {
  Args: {
    onClick: (event: MouseEvent) => void;
  };
  Element: HTMLButtonElement;
}

export default <template>
  <button
    type="button"
    aria-label="close"
    class="absolute btn btn--small btn--outline btn--cancel"
    {{on "click" @onClick}}
    ...attributes
  >
    &times;
  </button>
</template> satisfies TOC<CloseButtonSignature>;
